import { create } from "zustand";

export type LearningCenterVideo = {
  id: string;
  title: string;
  duration: number;
  thumbnailUrl: string;
  height: number | null;
  width: number | null;
};

interface LearningCenterState {
  openedVideo: LearningCenterVideo | null;
  videos: Array<LearningCenterVideo>;
  videosMap: Map<string, LearningCenterVideo>;
  lastUpdate: Date | null;
}

interface LearningCenterActions {
  setOpenedVideo: (learningCenterVideo: LearningCenterVideo) => void;
  setVideos: (videos: Array<LearningCenterVideo>) => void;
  addVideo: (video: LearningCenterVideo) => void;
}

type LearningCenterStore = LearningCenterState & LearningCenterActions;

const initState: LearningCenterState = {
  openedVideo: null,
  videos: [],
  videosMap: new Map(),
  lastUpdate: null,
};

export const useLearningCenterStore = create<LearningCenterStore>((set) => ({
  ...initState,
  addVideo: (video) =>
    set((state) => ({
      videos: [...state.videos, video],
    })),
  setOpenedVideo: (video) =>
    set(() => ({
      openedVideo: video,
    })),
  setVideos: (videos) =>
    set(() => ({
      videos,
      videosMap: new Map(videos.map((video) => [video.id, video])),
      lastUpdate: new Date(),
    })),
}));
